const RELOAD_AT_KEY = 'stale-chunk-reload-at';
const RELOAD_COOLDOWN_MS = 30_000;

// A tab opened before a deploy still runs the old entry bundle, which asks for
// lazy chunks the deploy removed. Reload once to pick up the new bundle; if a
// reload just happened, let the error reach the error page instead of looping.
export const handlePreloadError = (event: Event, reload: () => void) => {
  const lastReloadAt = Number(sessionStorage.getItem(RELOAD_AT_KEY) ?? 0);
  if (Date.now() - lastReloadAt < RELOAD_COOLDOWN_MS) {
    return;
  }
  event.preventDefault();
  sessionStorage.setItem(RELOAD_AT_KEY, String(Date.now()));
  reload();
};

export const installStaleChunkReloadHandler = () => {
  window.addEventListener('vite:preloadError', (event) =>
    handlePreloadError(event, () => window.location.reload())
  );
};
